import { render, staticRenderFns } from "./CustomerDashboard.vue?vue&type=template&id=209b6f53&scoped=true"
import script from "./CustomerDashboard.vue?vue&type=script&lang=js"
export * from "./CustomerDashboard.vue?vue&type=script&lang=js"
import style0 from "./CustomerDashboard.vue?vue&type=style&index=0&id=209b6f53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209b6f53",
  null
  
)

export default component.exports